import { autoinject } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import { UserAuditParameterModel } from "../../../../../models/manage/user.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { BaseHistoryTrail } from "../../../common/base-history-trail";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject()
export class UserAuditDialog extends BaseHistoryTrail<UserAuditParameterModel> {

    audits: any[] = [];

    constructor(private dialogClient: DialogClientService, private queriesClientService: QueriesClientService,
        notificationClientService: NotificationClientService, i18N: I18N, configService: ConfigService) {
        super(configService, notificationClientService, i18N);
    }

    protected onActivated() {
        this.refreshData();
    }

    refreshData() {
        this.queriesClientService.getData(`/odata/RightShipAudits/Genesis.GetAudits(entityTypeId=${this.item.entityType},entityId=${this.item.userId})?$orderby=timestamp desc`).then((res: any) => {
            this.audits = res.value;
        });
    }

    close() {
        this.dialogClient.hide();
    }
}